/* ============================================================
   Shop Products Drawer — web components
   ============================================================ */

class ShopProductsTrigger extends HTMLElement {
  connectedCallback() {
    this._drawer = null;
    this._visible = false;
    this._scrollPercent = parseFloat(this.getAttribute('scroll-percent')) || 15;

    this._button = this.querySelector('button');
    if (!this._button) return;

    this._button.hidden = true;

    this._button.addEventListener('click', this._onTriggerClick.bind(this));
    this._onScroll = this._handleScroll.bind(this);
    window.addEventListener('scroll', this._onScroll, { passive: true });

    if (Shopify.designMode) {
      this._show();
    } else {
      this._handleScroll();
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
  }

  get drawerId() {
    return this._button ? this._button.getAttribute('aria-controls') : null;
  }

  get drawer() {
    if (!this._drawer) {
      this._drawer = document.getElementById(this.drawerId);
    }
    return this._drawer;
  }

  _handleScroll() {
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var scrolledPercent = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0;
    var scrolledPast = scrolledPercent >= this._scrollPercent;

    if (scrolledPast && !this._visible) {
      this._show();
      window.removeEventListener('scroll', this._onScroll);
    }
  }

  _show() {
    this._visible = true;
    this._button.hidden = false;
    requestAnimationFrame(function() {
      this._button.classList.add('is-visible');
    }.bind(this));
  }

  _onTriggerClick() {
    var drawer = this.drawer;
    if (!drawer) return;

    var opening = !drawer.open;
    drawer.open = opening;
    this._button.setAttribute('aria-expanded', opening ? 'true' : 'false');

    if (drawer._closeListener) return;
    drawer._closeListener = true;
    drawer.addEventListener('openable-element:close', function() {
      this._button.setAttribute('aria-expanded', 'false');
    }.bind(this));
  }
}

window.customElements.define('shop-products-trigger', ShopProductsTrigger);


class ShopProductsDrawer extends DrawerContent {
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('role', 'dialog');
    this.setAttribute('aria-modal', 'true');

    var heading = this.querySelector('.drawer__title');
    if (heading && !this.hasAttribute('aria-labelledby')) {
      if (!heading.id) heading.id = 'shop-products-drawer-title-' + this.id;
      this.setAttribute('aria-labelledby', heading.id);
    }

    this.addEventListener('openable-element:open', this._onQuickBuyOpen.bind(this));
    this.addEventListener('openable-element:close', this._onQuickBuyClose.bind(this));
  }

  _onQuickBuyOpen(e) {
    if (e.target === this) return;
    if (!e.target.classList.contains('drawer--quick-buy') &&
        !e.target.classList.contains('popover--quick-buy')) return;
    this.classList.add('has-quick-buy-open');
  }

  _onQuickBuyClose(e) {
    if (e.target === this) return;
    if (!e.target.classList.contains('drawer--quick-buy') &&
        !e.target.classList.contains('popover--quick-buy')) return;

    var self = this;
    var el = e.target;
    var done = false;

    function remove() {
      if (done) return;
      done = true;
      el.removeEventListener('transitionend', onEnd);
      self.classList.remove('has-quick-buy-open');
    }

    function onEnd(evt) {
      if (evt.target === el) remove();
    }

    el.addEventListener('transitionend', onEnd);
    setTimeout(remove, 400);
  }
}

window.customElements.define('shop-products-drawer', ShopProductsDrawer);
